module.exports = __webpack_public_path__ + "41eaf1ca01607d0199d3cb057398f5b6.jpg";